export default function About() {
  return (
    <div className="container">
      <h1>About Us</h1>

      <p>
        Bloomora Naturals is a small India-based brand focused on creating
        thoughtfully crafted products inspired by nature and everyday living.
      </p>

      <p>
        We work with simple formulations, responsible sourcing, and a
        customer-first mindset to deliver products that are affordable, safe,
        and effective.
      </p>

      <p>
        Our product range includes home décor candles, personal care essentials,
        and eco-friendly home solutions. New products are introduced gradually
        as we grow.
      </p>

      <p>
        <strong>Founded:</strong> 2024 <br />
        <strong>Operating from:</strong> India
      </p>
    </div>
  );
}
